import { render, staticRenderFns } from "./ChartModal.vue?vue&type=template&id=23bfeabe&scoped=true&"
import script from "./ChartModal.vue?vue&type=script&lang=js&"
export * from "./ChartModal.vue?vue&type=script&lang=js&"
import style0 from "./ChartModal.vue?vue&type=style&index=0&id=23bfeabe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23bfeabe",
  null
  
)

export default component.exports